import { RefObject, useCallback, useEffect, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { debounce } from 'sdk';

import { useSDK } from '../../../../app';
import { useUIState } from './../../../../app/App';
import { useOnVisibleDocument } from './useOnVisibleDocument';

export const useOnScroll = (containerRef: RefObject<Scrollbars>): ((e: { target: HTMLDivElement }) => void) => {
	const { eventsStore, conversationsStore, loadHistoryMessages } = useSDK();
	const [shouldScrollToBottom, setShouldScrollToBottom] = useState(true);
	const [onScrollTarget, setOnScrollTarget] = useState<HTMLDivElement>();
	const documentIsVisible = useOnVisibleDocument();
	const { dateDelimiterStore, scrollStore } = useUIState();

	useEffect(() => {
		setTimeout(() => {
			shouldScrollToBottom &&
				containerRef.current &&
				containerRef.current?.scrollTop(containerRef.current?.getScrollHeight() || 0);
		});
	}, [containerRef, shouldScrollToBottom]);

	useEffect(() => {
		if (
			!conversationsStore.allHistoryLoaded &&
			containerRef.current?.getClientHeight() === containerRef.current?.getScrollHeight()
		) {
			loadHistoryMessages();
		}
	}, [containerRef, conversationsStore.allHistoryLoaded, loadHistoryMessages]);

	const markMessageAsRead = useCallback((): void => {
		if (
			documentIsVisible &&
			onScrollTarget &&
			onScrollTarget.scrollHeight - onScrollTarget.scrollTop < onScrollTarget.clientHeight + 1
		) {
			// пользователь промотал вниз
			eventsStore.markRead();
			setShouldScrollToBottom(true);
		} else {
			setShouldScrollToBottom(false);
		}
	}, [documentIsVisible, eventsStore, onScrollTarget]);

	useEffect(markMessageAsRead, [
		documentIsVisible,
		containerRef,
		conversationsStore.allHistoryLoaded,
		loadHistoryMessages,
		markMessageAsRead,
	]);

	const onScroll = debounce(
		useCallback(
			(e: { target: HTMLDivElement }) => {
				setOnScrollTarget(e.target);
				if (e.target.scrollTop < 800 && !conversationsStore.allHistoryLoaded) {
					loadHistoryMessages();
				}
				markMessageAsRead();
				scrollStore.onScroll(e.target);
				dateDelimiterStore.onScroll();
			},
			[
				conversationsStore.allHistoryLoaded,
				loadHistoryMessages,
				markMessageAsRead,
				dateDelimiterStore,
				scrollStore,
			]
		),
		30
	);

	return onScroll;
};
